import * as React from "react";
import styled from "styled-components";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { Text } from "src/library/components/Text";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";

import {
  useProductApprovalApi,
  ProductApprovalRequestName
} from "../api/product-approval.api";
import ProductApprovalDropdown from "./ProductApprovalDropdown";

export const ProductApprovalExportModal: React.ReactFCWithChildren<Pick<BasicModalProps, "onDismiss" | "open"> > = ({ onDismiss, open }) => {
  const [ exportApprovalListResponse, exportApprovalList ] = useProductApprovalApi(ProductApprovalRequestName.EXPORT_APPROVAL_LISTS);
  const [ productApprovalListToExport, setProductApprovalListToExport ] = React.useState<number | null>(0);

  React.useEffect(() => {
    if (exportApprovalListResponse.data) {
      toast.success(exportApprovalListResponse.data.message);
      exportApprovalListResponse.data = null;
      onDismiss();
    }
  }, [
    exportApprovalListResponse,
    exportApprovalListResponse.data,
    onDismiss
  ]);

  return (
    <StyledBasicModal
      title="Export Product Approval List"
      open={open}
      onDismiss={() => onDismiss()}
    >
      {exportApprovalListResponse.error && (
        <ErrorNotice
          message={exportApprovalListResponse.error.message}
          type="error"
        />
      )}

      {exportApprovalListResponse.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <Text as="p">
            The generated export will be the display product approvals lists with the latest effective date.
          </Text>

          <ProductApprovalDropdown
            updateSelectedProductApprovalList={setProductApprovalListToExport}
            value={productApprovalListToExport || 0}
            additionalOptions={[
              {
                text: "Export all",
                value: ""
              }
            ]}
          />

          <Button
            className="submit-button"
            disabled={productApprovalListToExport === 0}
            onClick={() => {
              if (productApprovalListToExport || productApprovalListToExport === null) {
                exportApprovalList({ productApprovalListId: productApprovalListToExport });
              } else {
                // should never happen. Ensuring approvalListId is set above before making request
                toast.error("Invalid Approval list id");
              }
            }}
          >
            Export
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
